import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { SNOWPLOW_SESSION_ID } from "@catchoftheday/analytics";
import { nanoid, nodeCookie, urlStringToParsedUrlQuery } from "@catchoftheday/utilities";
import { CataloguePageType, CUSTOMER_UUID_COOKIE_NAME, IS_MOBILE_COOKIE_NAME } from "../../../consts";
import { CatalogueBrowseContainer } from "../CatalogueBrowseContainer/CatalogueBrowseContainer";
import { CatalogueSearchContainer } from "../CatalogueSearchContainer/CatalogueSearchContainer.jsx";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var CataloguePageContainer = function CataloguePageContainer(_ref) {
  var props = _extends({}, _ref);

  var router = useRouter();
  var query = router.query,
      events = router.events,
      asPath = router.asPath;

  var _useState = useState(query),
      queryParams = _useState[0],
      setQueryParams = _useState[1];

  useEffect(function () {
    var handleRouteChange = function handleRouteChange(path) {
      var params = urlStringToParsedUrlQuery(path, window.location.origin);
      setQueryParams(params);
    };

    events.on("routeChangeComplete", handleRouteChange);
    return function () {
      events.off("routeChangeComplete", handleRouteChange);
    };
  }, [events]);

  if (props.pageType !== CataloguePageType.SEARCH) {
    return ___EmotionJSX(CatalogueBrowseContainer, _extends({}, props, {
      queryParams: queryParams,
      path: asPath
    }));
  }

  return ___EmotionJSX(CatalogueSearchContainer, _extends({}, props, {
    queryParams: queryParams
  }));
}; // We need getInitialProps for this feature to work as getServerSideProps is not guaranteed to run on the initial request

export var CataloguePageInitialProps = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    var _context$req;

    var cookie, parsedCookie, customerUuid, spSessionId, isMobile;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cookie = (_context$req = context.req) === null || _context$req === void 0 ? void 0 : _context$req.headers["cookie"];

            if (cookie) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", {
              spSessionId: nanoid()
            });

          case 3:
            parsedCookie = nodeCookie.parse(cookie);
            customerUuid = parsedCookie[CUSTOMER_UUID_COOKIE_NAME];
            spSessionId = parsedCookie[SNOWPLOW_SESSION_ID];
            isMobile = parsedCookie[IS_MOBILE_COOKIE_NAME] === "true";
            return _context.abrupt("return", {
              customerUuid: customerUuid,
              spSessionId: spSessionId,
              isMobile: isMobile
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function CataloguePageInitialProps(_x) {
    return _ref2.apply(this, arguments);
  };
}();